module.exports = __webpack_public_path__ + "img/DSC_1161.eb2b5de2.jpg";